import { UserDto } from '@fleet-beat/core';

export interface LogbookHistoryDto {
  driver?: UserDto;
  status: 'edited' | 'added' | 'removed';
  date?: string;
}
